import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { yandexMetrikaHit } from "../analytics/yandexMetrika";
import { ensureYandexMetrikaLoaded } from "../analytics/loadYandexMetrika";
import { isAnalyticsAllowed } from "../utils/cookieConsent";
import { captureAdAttributionFromUrl } from "../utils/adAttribution";

/**
 * Hit Метрики при SPA-навигации + захват yclid/UTM из URL.
 * Метрика грузится только после согласия на аналитические cookies.
 */
export default function YandexMetrikaTracker() {
  const location = useLocation();

  useEffect(() => {
    captureAdAttributionFromUrl(location.search);
    if (!isAnalyticsAllowed()) return;
    ensureYandexMetrikaLoaded().then((ok) => {
      if (ok) yandexMetrikaHit();
    });
  }, [location.pathname, location.search]);

  return null;
}
